import axios from 'axios';
import {toast} from 'react-toastify';
import config from "../config/apiService.json";
import {headers} from "./httpServices";
import logout from "./logout";

const {baseApiEndPoint} = config;

axios.interceptors.response.use(null, error => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

    if (!expectedError) {
        toast.error("Something unexpected happened!", {toastId: 'error1'});
        console.log("Logging Errors:", error);
    }


    return Promise.reject(error);
});

const fetchData = async (apiEndpoint) => {
    const finalApi = `${baseApiEndPoint}${apiEndpoint}`;
    try {
        const {data} = await axios(finalApi);
        const {success} = data;
        if (success) {
            const {payload} = data;
            return payload;
        } else {
            const {message} = data;
            toast.error(message, {toastId: 'error1'});
        }
    } catch (error) {
        if (error.response && error.response.status === 404) {
            console.log("Logging Errors:", error);
            toast.error("Content Not Found!", {toastId: 'error1'});
        }
    }
};

export const fetchDataWithAuth = async (apiEndpoint) => {
    const finalApi = `${baseApiEndPoint}${apiEndpoint}`;
    try {
        const {data} = await axios(finalApi, {headers});
        const {success} = data;
        if (success) {
            const {payload} = data;
            return payload;
        } else {
            const {message} = data;
            toast.error(message, {toastId: 'error1'});
        }
    } catch (error) {
        if (error.response && error.response.status === 404) {
            console.log("Logging Errors:", error);
            toast.error("Content Not Found!", {toastId: 'error1'});
        }
        if (error.response.status === 401) logout();
    }
};

export const fileDownload = async (fileName, fileType) => {
    try {
        if (fileName && fileType) {
            toast.success('File is processing for download!', {autoClose: false});
            const {data} = await axios(`${baseApiEndPoint}/file/download`, {
                params: {fileName: fileName, module: fileType},
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            toast.dismiss();
            link.click();
        } else {
            toast.error("Unable to download!");
        }
    } catch (error) {
        toast.error(error.message);
    }
}

export const dataToBlob = async (fileName, fileType) => {

    try {
        const {data} = await axios(`${baseApiEndPoint}/file/download`, {
            params: {fileName: fileName, module: fileType},
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([data]));
        return url;
    } catch (error) {
        toast.error(error.response.data.message);
    }

}

export default fetchData;
